/* eslint-disable import/prefer-default-export */
export const constant = {
  secret: 'dd5f3089-40c3-403d-af14-d0c228b05cb4',
  encryptedBase64Key: 'bXVzdGJlMTZieXRlc2tleQ==',
}
